import { useMemo, type RefObject } from 'react';
import type { MapRef } from 'react-map-gl/maplibre';
import type { Anomaly } from '@soc/shared';
import { clusterAlerts, type ClusterOrPin } from './clustering';

/**
 * Cluster active alerts for the current viewport. `version` is an explicit
 * recompute trigger (bumped on map load + moveEnd) because projection depends on
 * zoom/center, which aren't React state. Before the map loads, `getMap()` is
 * null and every alert falls back to an individual pin.
 */
export function useClusters(
  alerts: Anomaly[],
  mapRef: RefObject<MapRef>,
  version: number,
): ClusterOrPin[] {
  return useMemo(() => {
    const map = mapRef.current?.getMap();
    if (!map) return alerts.map((alert) => ({ kind: 'pin', alert }) as ClusterOrPin);
    return clusterAlerts(alerts, map);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [alerts, version]);
}
